// extracted by mini-css-extract-plugin
export var subtitle = "_br-2";
export var title = "_br-0";
export var titleNoWrap = "_br-1";